import React from 'react';

import { Card, Empty, List } from 'antd';

interface Props {
    recommendations: string[];
}

export default function Recommendations(props: Props) {
    if (!props.recommendations || props.recommendations.length === 0) {
        return (
            <Card title="Рекомендации" style={{ marginBottom: 16 }}>
                <Empty description="Нет рекомендаций" />
            </Card>
        );
    }

    return (
        <Card title="Рекомендации" style={{ marginBottom: 16 }}>
            <List
                dataSource={props.recommendations}
                renderItem={(item, idx) => <List.Item>{`${idx + 1}. ${item}`}</List.Item>}
            />
        </Card>
    );
}
